import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFileTypesSearchText = createSelector(
  [(store: RootState) => store.fileTypes.searchText],
  (data) => data
);